import {Unity, useUnityContext} from "react-unity-webgl"
import {modalType} from "./Modal"
import {useCallback, useEffect} from "react"
import {useClientContext} from "../contexts/ClientContext"

export default function Game() {

    const {currentUser, setModalData, setShowModal, updateFRGBalance, unityUnloading, setUnityUnloading} = useClientContext()
    const {unityProvider, isLoaded, loadingProgression, addEventListener, removeEventListener, sendMessage, unload, UNSAFE__detachAndUnloadImmediate: detachAndUnloadImmediate, UNSAFE__unityInstance: unityInstance} = useUnityContext({
        loaderUrl: "/FCCollect-Web/Build/FCCollect-Web.loader.js",
        dataUrl: "/FCCollect-Web/Build/FCCollect-Web.data",
        frameworkUrl: "/FCCollect-Web/Build/FCCollect-Web.framework.js",
        codeUrl: "/FCCollect-Web/Build/FCCollect-Web.wasm",
        streamingAssetsUrl: "/FCCollect-Web/StreamingAssets"
    });


    const handleSendTokens = useCallback(async (amount) => {
        if (amount < 1) return

        async function sendTokens(address, amount) {
            const urlPrefix = process.env.REACT_APP_URL_PREFIX || ''
            try {
                await fetch(`${urlPrefix}/api/tokens`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        address: address,
                        amount: amount.toFixed(2)
                    })
                })
            } catch (e) {
                console.log(e.message);
            }
        }

        try {
            setModalData({
                type: modalType.InfoSpinner,
                title: "Congrats!",
                message: `You've collected ${amount} ${(amount > 1) ? 'gems' : 'gem'}! Please wait while they are transferred to your account.`
            })
            setShowModal(true)
            await sendTokens(currentUser.addr, amount)
            setShowModal(false)
            updateFRGBalance()
        } catch (e) {
            setModalData({
                type: modalType.Error,
                title: "Error",
                message: (e && e.message) || e
            })
        }
    }, [currentUser, setModalData, setShowModal, updateFRGBalance]);

    useEffect(() => {
        addEventListener("SendTokens", handleSendTokens)
        return () => {
            removeEventListener("SendTokens", handleSendTokens)
        }
    }, [addEventListener, removeEventListener, handleSendTokens])

    useEffect(() => {
        const teardown = async () => {
            if(isLoaded) {
                console.log("UNITY UNLOADING")
                setUnityUnloading(true)
                await detachAndUnloadImmediate()
                // await unload()
                setUnityUnloading(false)
            }
        }
        return () => {
            teardown()
        }
    }, [isLoaded, sendMessage, setUnityUnloading, unload])

    const loadingPercentage = Math.round(loadingProgression * 100);

    return (
        <div className={'relative flex'}>
            {isLoaded === false && (
                // We'll conditionally render the loading overlay if the Unity
                // Application is not loaded.
                <div className="absolute mx-auto inset-0 z-10">
                    <div className={'relative text-center pt-10'}>
                        <p className={'text-gray-100 mx-auto'}>Loading... ({loadingPercentage}%)</p>
                    </div>
                </div>
            )}
            <Unity unityProvider={unityProvider} style={{width: 1024, height: 512}} />
        </div>
    )
}